import React from 'react';

import PropTypes from 'prop-types';

import './banner.scss';

class HeroBanner extends React.Component {
  constructor(props) {
    super(props);

    this.copyIndex = 0;
    this.copy = props.data;

    this.state = {
      large: this.getBannerLarge(),
      color: this.getBannerColor(),
      border: this.getBorderColor(),
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.animateCursorIn();
    }, 300);

    setTimeout(() => {
      this.changeText();
    }, 1000);
  }

  getBannerLarge = () => this.copy[this.copyIndex].phrase_object.phrase

  getBannerColor = () => this.copy[this.copyIndex].phrase_object.colour

  getBorderColor = () => `${this.copy[this.copyIndex].phrase_object.colour}-b`

  setNewCopyIndex = () => {
    if (this.copyIndex < this.copy.length - 1) {
      this.copyIndex = this.copyIndex + 1;
    } else {
      this.copyIndex = 0;
    }
  }

  getAnimation = () => {
    switch (this.state.animate) {
      case 'in': {
        return 'animate-in';
      }

      case 'out': {
        return 'animate-out';
      }

      case 'cursor-in': {
        return 'animate-cursor-in';
      }

      case 'cursor-out': {
        return 'animate-cursor-out';
      }

      default: {
        return '';
      }
    }
  }

  animateCursorOut = () => {
    this.setState({ animate: 'cursor-out' });
  }

  animateCursorIn = () => {
    this.setState({ animate: 'cursor-in' });
  }

  animateBannerIn = () => {
    this.setState({ animate: 'in' });
  }

  animateBannerOut = () => {
    this.setState({ animate: 'out' });
  }

  changeText = () => {
    this.animateBannerIn();

    setTimeout(() => {
      this.animateBannerOut();
    }, 2000);

    setTimeout(() => {
      this.updateBanner();
    }, 3590);

    setTimeout(() => {
      this.changeText();
    }, 4000);
  }


  updateBanner = () => {
    this.setNewCopyIndex();

    this.setState({
      color: this.getBannerColor(),
      large: this.getBannerLarge(),
      border: this.getBorderColor(),
    });
  }

  render() {
    const currentColourClass = `${this.state.border} ${this.state.color}`;
    const animation = this.getAnimation();

    return (
      <div className="banner-holder">
        <div className={`${currentColourClass} animation-box ${animation}`}>
          <h1 className="title">{this.state.large}<span /></h1>
        </div>
        <h1 className="title">&nbsp;</h1>
      </div>
    );
  }
}

HeroBanner.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    phrase_object: PropTypes.shape({
      phrase: PropTypes.string.isRequired,
      colour: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired).isRequired,
};

export default HeroBanner;



// WEBPACK FOOTER //
// ./src/components/Hero/HeroBanner/index.jsx